import React from "react"
import { Button } from 'primereact/button';
import { Dialog } from "primereact/dialog";
import { FormSectionElements, FormSections, FormSubSections, LOVValues } from "../../entities/formTemplateDataType";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { dateComparisonList, odsCallOutBoxs, textBoxLengths, TextType, textTypeOption } from "../../entities/Constants";
import { Checkbox } from "primereact/checkbox";
import { InputTextarea } from "primereact/inputtextarea";
import { Editor } from "primereact/editor";


interface Props {
    ele: FormSectionElements;
    dialogVisible: boolean;
    isEng: boolean;
    callback;
}
interface State {
    pickedFieldOptions;
}
export class DialogForTextComponent extends React.Component<Props,State> {

    dateTypeFieldList = [];
    subSection: FormSubSections;

    constructor(props: Props) {
        super(props);
        this.state = {
            pickedFieldOptions: [],
        };
        this.subSection = this.props.ele.parent as FormSubSections;
        this.dateTypeFieldList = this.subSection.ListOfFormSectionElements?.filter(p => p.Datatype === 'Date' && p.Sequence < this.props.ele.Sequence);
    }

    componentDidMount(): void {
        if(this.props.ele.FilterField!=null){
            this.onChangeHanlder(this.props.ele.FilterField)
        }
    }


    generateHtmlString = () => {
        let html = [];
        html.push(
            <>
                {/* @ts-ignore */}
                <Dialog header={this.props.isEng ? "Field Properties for " + this.props.ele.ENUTitle : "Field Properties for " + this.props.ele.FRATitle} footer={this.renderFooter()}
                    visible={this.props.dialogVisible} style={{ width: '50vw' }} onHide={() => this.props.callback(false)}>
                    {this.otherPreviousDateFields()}
                </Dialog>
            </>
        );
        return html;
    }

    onChangeHanlder = (newValue) => {
        this.props.ele.FilterField = newValue;
        let currentSection = this.subSection.parent as FormSections;
        let totalOption = [];
        const sections = currentSection.parent.ListOfFormSections;
        sections.filter(p=>p.Sequence<=currentSection.Sequence).forEach((section)=>{
             section.ListOfFormSubSections.forEach((sub) => {
            let eleListPrior = sub.ListOfFormSectionElements.filter(p => p.Sequence < this.props.ele.Sequence|| sub.Sequence<this.subSection.Sequence);
            let pickedFieldOptions = eleListPrior.filter(
                (ele) =>
                        ele.LoadBindName.replace(/\s/g, "") == newValue
            ).map((q) => {
                const container = {};
                container[q.LoadBindName] = q.ListOfLOVValues;
                return container;
            });
            totalOption.push(...pickedFieldOptions);
        })
        });
       
        this.setState({ pickedFieldOptions: totalOption });
        this.props.callback();
    }

    otherPreviousDateFields = () => {

        let elementListWithOptions = [];
  
        let allElements=[];

        let section = this.subSection.parent as FormSections;
        
        //get the section list prior to this one
       if(this.props.ele.parent.parent?.Datatype!=="Row"){
    section.ListOfFormSubSections.forEach(sub=>{
             let elementList =sub.ListOfFormSectionElements.filter(p=>p.Sequence<this.props.ele.Sequence && sub.Sequence==this.subSection.Sequence || sub.Sequence<this.subSection.Sequence);
             allElements.push(...elementList);
        });

        let list = allElements.filter(
            (q) =>
            (q.Datatype === "RadioButton" ||
                q.Datatype === "CheckGroup" ||
                q.Datatype === "Dropdown")
        ).map((q) => {
            return {
                code: q.LoadBindName?.replace(/\s/g, ""),
                description: this.props.isEng ? q.ENUTitle : q.FRATitle
            };
        });
        // elementListWithOptions.push('')
        elementListWithOptions.push(...list);

       }
    

        let htmlString = [];

        htmlString.push(
            <div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Script</div>
                    <div style={{ width: '60%' }}>
                        <InputTextarea className="ontario-input"
                            value={this.props.ele.Script} onChange={(e) => {
                                this.props.ele.Script = e.target.value;
                                this.props.callback();
                            }}></InputTextarea></div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Init Script</div>
                    <div style={{ width: '60%' }}>
                        <InputTextarea className="ontario-input"
                            value={this.props.ele.InitScript} onChange={(e) => {
                                this.props.ele.InitScript = e.target.value;
                                this.props.callback();
                            }}></InputTextarea></div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Key Stroke Script</div>
                    <div style={{ width: '60%' }}>
                        <InputTextarea className="ontario-input"
                            value={this.props.ele.KeyStrokeScript} onChange={(e) => {
                                this.props.ele.KeyStrokeScript = e.target.value;
                                this.props.callback();
                            }}></InputTextarea></div>
                </div>
               <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Field Length</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Dropdown showClear options={textBoxLengths} optionLabel='label' optionValue='val' value={this.props.ele.Length} onChange={(e) => {
                           this.props.ele.Length = e.target.value;
                           this.props.callback();
                        }}></Dropdown>
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Regular Expression</div>
                    <div style={{ width: '60%' }}><InputText className="ontario-input" value={this.props.ele.RegularExpression} onChange={(e) => {
                        this.props.ele.RegularExpression = e.target.value;
                        this.props.callback();
                    }}></InputText></div>
                </div>
         <div style={{ display:  "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Empty Error Message</div>
                    <div style={{ width: '60%' }}><InputText className="ontario-input" value={this.props.isEng? this.props.ele.EmptyErrorMessage:this.props.ele.EmptyErrorMessageFRA}
                        onChange={(e) => {
                            if (this.props.isEng)
                                this.props.ele.EmptyErrorMessage = e.target.value;
                            else 
                                this.props.ele.EmptyErrorMessageFRA=e.target.value;
                            this.props.callback();
                        }}></InputText></div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Custom Error Message</div>
                    <div style={{ width: '60%' }}><InputText className="ontario-input" value={this.props.isEng ?this.props.ele.ErrorMessage:this.props.ele.ErrorMessageFRA} onChange={(e) => {
                        if(this.props.isEng)
                            this.props.ele.ErrorMessage = e.target.value;
                        else 
                            this.props.ele.ErrorMessageFRA = e.target.value;
                        this.props.callback();
                    }}></InputText></div>
                </div>

       

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Question Hint</div>
                    <div style={{ width: '60%'}}>
                        {/* @ts-ignore */}
                        <Editor   style={{ height: 'auto' }} 
                            value={this.props.isEng ? this.props.ele.Hint : this.props.ele.HintFR} onTextChange={(e) => {
                            if (this.props.isEng)
                                this.props.ele.Hint = e.htmlValue;
                            else
                                this.props.ele.HintFR = e.htmlValue;

                            this.props.callback();
                        }}></Editor>
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Tool Tip</div>
                    <div style={{ width: '60%' }}><InputText className="ontario-input" 
                    value={this.props.isEng ? this.props.ele.TooltipENU : this.props.ele.TooltipFRA} onChange={(e) => {
                        if (this.props.isEng)
                            this.props.ele.TooltipENU = e.target.value;
                        else
                            this.props.ele.TooltipFRA = e.target.value;

                        this.props.callback();
                    }}></InputText></div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Hint Expansion Title</div>
                    <div style={{ width: '60%' }}><InputText className="ontario-input" 
                    value={this.props.isEng?this.props.ele.hintExpansionTitle:this.props.ele.hintExpansionTitleFRA }
                        onChange={(e) => {
                            if (this.props.isEng){
                                this.props.ele.hintExpansionTitle = e.target.value;
                            } else{
                                this.props.ele.hintExpansionTitleFRA = e.target.value;
                            }
                                
                            this.props.callback();
                        }}></InputText></div>
                </div>

                {/* Alert box options */}
                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Callout Box</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Dropdown showClear options={odsCallOutBoxs} optionLabel='label' optionValue='val' value={this.props.ele.callOutBoxType} onChange={(e) => {
                            this.props.ele.callOutBoxType = e.value;
                            this.props.callback();
                        }}></Dropdown>
                    </div>
                </div>

                <div style={{ display: this.props.ele.callOutBoxType != null ? "flex" : "none", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Callout Box Title</div>
                    <div style={{ width: '60%' }}><InputText className="ontario-input" 
                    value={this.props.isEng?this.props.ele.callOutBoxTitle:this.props.ele.callOutBoxTitleFRA}
                        onChange={(e) => {
                            if (this.props.isEng)
                                this.props.ele.callOutBoxTitle = e.target.value;
                            else
                                this.props.ele.callOutBoxTitleFRA = e.target.value;

                            this.props.callback();
                        }}></InputText></div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Callout Box Body Message</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Editor className="ontario-input" value={this.props.isEng ? this.props.ele.callOutBoxBody : this.props.ele.callOutBoxBodyFRA}
                            onTextChange={(e) => {
                                if (this.props.isEng)
                                    this.props.ele.callOutBoxBody = e.htmlValue;
                                else
                                    this.props.ele.callOutBoxBodyFRA = e.htmlValue;
                                this.props.callback();
                            }}></Editor>
                    </div>
                </div>


                <div style={{ display:  "flex",  marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Filtering Field</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Dropdown options={elementListWithOptions} style={{width:'100%'}}
                            className="ontario-dropdown-small"
                            optionLabel="description"
                            optionValue="code"
                            value={this.props.ele.FilterField}
                            onChange={(e) => {
                                this.onChangeHanlder(e.value);}
                            }></Dropdown></div>
                </div>
                <div style={{ display:  "flex" , marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Filtering Value</div>
                    <div style={{ width: '60%', marginTop: '5px' }}>
                        <div>
                            {/* @ts-ignore */}
                            <Dropdown style={{width:'100%'}}
                                className="ontario-dropdown-small"
                                options={this.state.pickedFieldOptions[0] != null ? this.state.pickedFieldOptions[0][this.props.ele.FilterField] : null}
                                value={this.props.ele.FilterValue}
                                optionLabel="description"
                                optionValue="code"
                                placeholder="Filtering value"
                                onChange={(e) => {
                                    this.props.isEng ? (this.props.ele.FilterValue = e.value) : (this.props.ele.FilterValueFRA = e.value);
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>

                    <div style={{ width: '25%' }}>
                        <label htmlFor={"text_type_" + this.props.ele.Sequence}>Text type:</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Dropdown options={textTypeOption} style={{width:'100%'}} id={"text_type_" + this.props.ele.Sequence}
                            className="ontario-dropdown-small"
                            optionLabel="label"
                            optionValue="val"
                            value={this.props.ele.TextType}
                            onChange={(e) => {
                                this.props.ele.TextType = e.target.value as TextType;
                                this.props.callback()
                            }}
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"maskinsummary_" + this.props.ele.Sequence}>Mask in Summary</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.ele.MaskInSummary} id={"maskinsummary_" + this.props.ele.Sequence}
                            onChange={(e) => { this.props.ele.MaskInSummary = e.checked; this.props.callback() }} checked={this.props.ele.MaskInSummary} />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"triggerSubmit_" + this.props.ele.Sequence}>Enable Submit on Enter:</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.ele.triggerSubmitOnEnter} id={"triggerSubmit_" + this.props.ele.Sequence}
                            onChange={(e) => { this.props.ele.triggerSubmitOnEnter = e.checked; this.props.callback() }} checked={this.props.ele.triggerSubmitOnEnter} />
                    </div>
                </div>
            </div>
        )
        return htmlString;
    }

    renderFooter = () => {
        return (
            <div>
                {/* @ts-ignore */}
                <Button label="OK" icon="pi pi-check" onClick={() => {
                    this.props.callback(false);
                }} />
                {/* @ts-ignore */}
                <Button label="Cancel" onClick={() => { this.props.callback(false) }} />

            </div>
        );
    }

    render() {
        return (
            this.generateHtmlString()
        )
    }
}
